<template>
  <section class="open-salud-about">
    <v-row class="row container-assistance reverse-sm ptop">
      <v-col sm="6" class="main-container-text px-lg-16 my-auto nopadtop">
        <h3 class="title-wellness" v-html="$t('firstblock.title')"></h3>
        <v-row class="videodetails">
            <p><v-icon large class="play-icon" v-text="'mdi-play-circle-outline'"></v-icon>{{ $t("firstblock.videodetails") }}</p>
        </v-row>
        <v-row>
            <v-col cols="12">
                <img src="/static-appopensalud/img/landings/wellness/01.png" width="100%"/>
            </v-col>
            <v-col cols="12">
                <img src="/static-appopensalud/img/landings/wellness/02.png" width="100%"/>
            </v-col>
            <v-col cols="12">
                <img src="/static-appopensalud/img/landings/wellness/03.png" width="100%"/>
            </v-col>
            <v-col cols="12">
                <img src="/static-appopensalud/img/landings/wellness/04.png" width="100%"/>
            </v-col>
        </v-row>
      </v-col>
      <v-col sm="6" class="main-container-text px-lg-16 column-invert heightauto">
         <h3 class="title-wellness-invert">{{ $t("firstblock.titleInvert") }}</h3>
         <h4 class="subtitle-wellness-invert">{{ $t("firstblock.subtitleInvert") }}</h4>
         <div class="subtitle-list subtitle-list mt-sm-5 iconlist">
            <p><v-icon large class="" v-text="'mdi-heart-pulse'"></v-icon>{{ $t("firstblock.iconsubtitle1") }}</p>
            <p><v-icon large class="" v-text="'mdi-spa-outline'"></v-icon>{{ $t("firstblock.iconsubtitle2") }}</p>

        </div>
        <h3 class="title-wellness-invert-small">{{ $t("firstblock.titleInvert2") }}</h3>
         <h4 class="subtitle-wellness-invert">{{ $t("firstblock.subtitleInvert2") }}</h4>
         <v-col cols="12" class="imgwell">
                <img src="/static-appopensalud/img/landings/wellness/espalda-sana.jpg" width="100%"/>
        </v-col>
      </v-col>
    </v-row>

  </section>
</template>

<script>
import es from '@/lang/es/public/views/primesalud-wellness.json'
import en from '@/lang/en/public/views/primesalud-wellness.json'

export default {
  name: 'opensaludpass-main-block',
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  data () {
    return {
      items: [
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-1'),
          path: 'medic-assistance'
        },
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-2'),
          path: 'wellness'
        },
        {
          icon: 'mdi-check-circle-outline',
          text: this.$t('subtitle-list-3'),
          path: 'discounts'
        }
      ]
    }
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$t('header-title')
      }
    },
    subtitle: {
      type: String,
      default () {
        return this.$t('upper-header-subtitle')
      }
    },
    button_text: {
      type: String,
      default () {
        return this.$t('hire-now-with-price')
      }
    },
    label_text: {
      type: String,
      default () {
        return this.$t('learn-more-btn')
      }
    }
  },
  methods: {
    buy () {
      this.$helpers.goToWebApp(
        '#dlgRegisterPatient?returnUrl=/HomePaciente#/profile/addsubscription/opensaludpass'
      )
    }
  }
}
</script>

<style lang='scss'>
@import '../../../static-appopensalud/css/public/layout.scss';

    .reverse-sm {
  @include media(mobile, tablets) {
    flex-direction: column !important;
  }
  }


.imgwell{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.heightauto{
    min-height: auto !important;
}

.play-icon{
        color: #3333cc !important;
        padding-right: 15px !important;
}

.icons-invert{
            font-size: 7em !important;
}
.video-quantity{
            color: #3333cc !important;
        font-size: 2em !important;
        font-weight: 600 !important;
}
.icons-invert-title{
        font-size: 2em !important;
}

.icons-invert-subtitle{
    font-size: 1.5em !important;
}
.video-details{
                color: #3333cc !important;
        font-size: 1.5em !important;
}
.priceshadow{
    margin-top: 2em !important;
    background-color: white;
        text-align: center;
    box-shadow: -28px -28px 45px rgba(131, 131, 131, 0.185);
    border-radius: 40px;

}
.column-invert {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  @include section;
  background-color: $black;

  h3 {
    color: $white;
  }

  .content {
    @include container-padding;

    @include desktop {
      padding: {
        top: 4rem;
        bottom: 4rem;
      }
    }

  }

  .subtitle {
    @include desktop-sm {
      width: 100% !important;
    }

    p {
      color: $gray;
    }

    span {
      color: $gray
    }
    .subtitle-list {
      &.subtitle-list-large {
        p {
          color: $white;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
      }
      &:not(.subtitle-list-large) {
        span {
          color: $white;
        }
      }
      span {
        font-size: 1.25rem;
        display: inline-block;
      }
      > div {
        margin-bottom: 1rem;
        color: $white;
        > span {
          font-size: 1.5rem;
        }
      }

      .v-icon {
        color: $gray;
        margin-right: 1rem;
      }
    }
  }

  .col-bg {
    width: 100%;
  }
}
.title-wellness{
    font-size: 3.5rem !important;
line-height: 3.5rem !important;

}

.title-wellness-invert{
  font-size: 3.5rem !important;
  line-height: 3.5rem !important;
}

.title-wellness-invert-small{
  font-size: 2.5rem !important;
  line-height: 2.5rem !important;
}

.videodetails p{
    color: #3333cc !important;
}
.subtitle-wellness-invert{
    font-size: 1em !important;
line-height: 1.6rem !important;
color: #8A8A8A !important;
}
.iconlist{
}
.iconlist p{
  font-size: 1.25rem !important;
  color: #8A8A8A !important;
  font-weight: bold !important;
}

.iconlist p i{
  padding-right: 15px !important;
  color: #8A8A8A !important;
}
.title-offer{
    font-size: 2em !important;
    color:black !important;
    font-weight: 600 !important;
}

.price-before{
    color: #87888a !important;
    font-size: 3em !important;
    text-decoration:line-through;
}

.price-after{
    color: #3333cc !important;
    font-weight: 600 !important;
    font-size: 3em !important;
}

.subtitle-offer-1{
        color: #87888a !important;
    font-size: 1.5em !important;
}

.subtitle-offer-2{
    color: #3333cc !important;
    font-size: 1.5em !important;
}

.subtitle-offer-3{
    color: black !important;
    font-size: 2em !important;
    font-weight: 600 !important;
}

.asterisk{
    color: black !important;
    font-size: 0.5em !important;
}
.asterisk-text{
    color: black !important;
    font-weight: 600 !important;
    font-size: 1em !important;
}
.btn1 {
  max-width: 22em;
}
.row {
  margin: 0;
}

[class*="col-"] {
  padding: 0px;
}

section.open-salud-about {
  background-color: #e4e4e4;
  font-family: "Space Grotesk", sans-serif;
  text-align: left;
  position:relative;
}

.open-salud-about p {
  color: black;
  line-height: 1.2;
  font-weight: 400;
  font-size: 1rem;
}

.open-salud-about h3 {
  font-size: 4rem;
  line-height: 4.5rem;
  margin-top: 1rem;
}
.open-salud-about .main-container-text {
  @include container-padding;
}
.open-salud-about .container-assistance {
  margin: 0px;
  min-height: 100vh;

  @include media(mobile, tablets) {
    flex-direction: column-reverse;
  }
}

.open-salud-about .v-btn {
  color: #3238c4;
  border-color: #3238c4;
  font-size: 0.8rem;
  box-shadow: 13px 12px 39px -5px #87888a;
  background-color: #fff;
}

.open-salud-about .col-img {
  background-color: #fbfafa;
  padding: 0;
  margin-left: 0;
  background-image: url("/static-appopensalud/img/bgs/family-sitting-on-sofa.jpg");
  background-size: cover;
  background-position: center;
  min-height: 50vh;
}

.open-salud-about .g-image {
  width: 100vw;
}

.open-salud-about .v-list.v-sheet.theme--light {
  background-color: transparent;
}
.open-salud-about .v-list-item__title {
  white-space: normal;
}

.open-salud-about .v-list-item.v-list-item--link.theme--light {
  padding: 0;
  width: 25rem;
}
.open-salud-about .floating-container {
  position: relative;
}
.open-salud-about .floating-text {
  color: #3238c4;
  border-right: 1px solid #3238c4;
  padding: 0px 0 0rem 0rem;
  cursor: pointer;
  height: 7.5rem;
  position: absolute;
  left: 90%;
}

.open-salud-about .floating-label {
  transform: rotate(-90deg);
  color: #3238c4;
  font-family: "Space Grotesk", sans-serif;
  right: -2%;
  position: absolute;
  top: 20%;
  margin-top: 4rem;
  font-size: 0.8rem;
}


@media (max-width: 1263px) {
  .open-salud-about .floating-text {
    bottom: 0;
  }

  .open-salud-about .floating-label {
    right: 0;
    margin-top: -9%;
  }
  .open-salud-about .container-assistance {
    display: flex;
  }
  .open-salud-about .main-container-text,
  .open-salud-about .col-img {
    max-width: 50%;
  }

  .open-salud-about .button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: initial;
    align-items: baseline;
  }
    .open-salud-about h3 {
      margin-top: 3rem;
    }
}
@media (max-width: 1024px) {
  .open-salud-about .main-container-text,
  .open-salud-about .col-img {
    max-width: none;
  }
}
@media (max-width: 600px) {

.subtitle-offer-1{
    font-size: 0.9em !important;
}

.subtitle-offer-2{
    font-size: 1em !important;
}
  .title-discount-invert{
    font-size: 2em !important;
}
.subtitle-discount-invert{
    font-size: 1.2em !important;
}
.iconlist p{
  font-size: 1rem !important;
}
.iconlist div p{
  font-size: 1.2em !important;
}

.iconlist div p i{
  font-size: 2em !important;
}

.play-icon{

}


  .open-salud-about .floating-text {
    left: 85%;
  }

  .open-salud-about .floating-label {
    margin-top: -11%;
  }
  .open-salud-about .main-container-text {
    padding: 2rem;
  }
  .open-salud-about h3 {
      width: 100%;
      margin-left: 0;
      margin-top: 1rem;
      font-size: 2rem;
      line-height: 2.5rem;
    }
  .open-salud-about .v-list-item.v-list-item--link.theme--light {
    width: 70vw;
  }
  .open-salud-about.floating-text,
  .open-salud-about.button-floating {
    margin-bottom: 1rem;
    color: #3238c4;
    display: flex;
    justify-content: space-evenly;
    align-items: baseline;
  }

  .open-salud-about.section-icons {
    margin-top: 35rem;
  }
}

.learn-more {
  position: absolute;
  bottom: 0;
  color: #3238c4;
  border-left: 1px solid #3238c4;
  padding: 0 0 2rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition-duration: 0.5s;

  &:hover {
    font-size: 1rem;
    transition-duration: 0.5s;
  }

  span {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }


  @include desktop {
    left: 45vw;
  }

  @include tablets {
    right: 7rem;
    left: initial;
  }

  @include mobile {
    right: 2rem;
    left: initial;
  }
}

.main-container-text  {
  @include desktop {
    padding-top: 100px;
  }
}

@media screen and (min-width: 3840px) {
//For 4K Displays (Ultra HD)
    .heightauto {
        padding-top: 21rem !important;
    }
}

@media (min-width: 1199.98px)  {
    .nopadtop{
      padding-top: 0px !important;
    }
}

@media (max-width: 575.98px) {
      .ptop{
    padding-top: 5em;
    padding-bottom: 5em;
  }

    .title-wellness{
    font-size: 1.75rem !important;
    line-height: 2.5rem !important;

}

  .title-wellness-invert{
    font-size: 1.75rem !important;
line-height: 2.5rem !important;
}
 }

</style>



// WEBPACK FOOTER //
// src/components/public/PrimesaludWellnessMainBlock.vue